// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","spinner":"App_spinner__bIZjU","spinner__icon":"App_spinner__icon__aD+jS","container":"App_container__4L7Vo"};